// Enlaces del flujo presupuestado (#1290): Presupuestos, Ingresos y el CRM se
// mandan entre sí. Aparte de `config.tsx` para no crear un ciclo de imports.

export const BUDGETS_PATH = "/expenses/budgets";
export const INCOME_PATH = "/expenses/income";
export const CRM_FORECAST_PATH = "/crm/panel/pronostico";
export const CRM_DEALS_PATH = "/crm/negocios";
export const CRM_INVOICES_PATH = "/crm/negocios/facturas";
/** CRM → Negocios → Cotizaciones y el armador de una (#1545/#1546). */
export const CRM_QUOTES_PATH = "/crm/negocios/negocios/cotizaciones";
export const crmQuotePath = (quoteId: string) => `${CRM_QUOTES_PATH}/${encodeURIComponent(quoteId)}`;
/** Cobranza → Pagos: el calendario pago por pago del mismo ingreso esperado (#1324). */
export const COLLECTION_PAYMENTS_PATH = "/cobranza/pagos";
